// extracted by mini-css-extract-plugin
module.exports = {"errorWrap":"_1Jemj","logoImage":"_2bbm1","errorTitle":"Df8uz","errorPara":"_2SQ71","graphic":"_2YJVP","errorLastText":"O6p8B"};